import { V2CopyButton } from "@stacklet/ui";
import { graphql, useFragment } from "react-relay";

import { Link } from "app/components/links/Link";

import { Copyright } from "./Copyright";

import type { AppVersion_version$key } from "./__generated__/AppVersion_version.graphql";

interface Props {
  platform: AppVersion_version$key;
}

function VersionRow({
  label,
  value,
  action,
}: {
  label: string;
  value: React.ReactNode;
  action?: React.ReactNode;
}) {
  return (
    <div className="flex items-center justify-between gap-x-md">
      <div className="flex flex-col">
        <span className="text-label-medium text-text-primary">{label}</span>
        <span className="text-label-small text-text-secondary">{value}</span>
      </div>
      {action}
    </div>
  );
}

export function AppVersion({ platform }: Props) {
  const data = useFragment(
    graphql`
      fragment AppVersion_version on Platform {
        cloudCustodianVersion
        version
      }
    `,
    platform,
  );

  const uiHash = import.meta.env.VITE_GIT_HASH ?? "";

  return (
    <div className="flex flex-col gap-y-sm rounded-xl border border-overlay-medium bg-overlay-light p-md shadow backdrop-blur-md">
      <VersionRow
        action={
          <V2CopyButton
            copyLabel="Platform version"
            tooltipTarget="icon"
            value={data.version}
          />
        }
        label="Platform Version"
        value={data.version}
      />
      <VersionRow
        action={
          <V2CopyButton
            copyLabel="Console version"
            tooltipTarget="icon"
            value={uiHash}
          />
        }
        label="Console Version"
        value={uiHash}
      />
      <VersionRow
        label="c7n Version"
        value={
          <Link
            className="text-label-small"
            href="https://github.com/cloud-custodian/cloud-custodian/releases"
          >
            {data.cloudCustodianVersion}
          </Link>
        }
      />
      <hr className="border-overlay-medium" />
      <Copyright className="text-label-small" />
    </div>
  );
}
